import { FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import React, { useState } from "react";
import CodPayment from "./CodPayment";
import { t } from "i18next";

const Payment = ({ SelectedAddress = "", isPickup }) => {
  const [status, setStatus] = useState(0);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null); // State for the selected payment method

  const paymentHandler = (method) => {
    setSelectedPaymentMethod(method);
    setStatus(method === "cod" ? 1 : 2); // Set status based on payment method
  };

  return (
    <div className="payment-wrapper">
      <Typography variant="body2" sx={{ fontWeight: "bold", paddingBottom: 2 }}>
        2. Payment Methods
      </Typography>

      <RadioGroup
        aria-labelledby="demo-form-control-label-placement"
        name="position"
        className="payment"
        value={selectedPaymentMethod} // Set value to selected payment method
      >
        {/* Conditional render of "Cash On Delivery" option */}
        <FormControlLabel
          value="cod"
          control={<Radio />}
          label={t("Cash On Delivery")}
          onChange={() => paymentHandler("cod")} // Update selected payment method
        />

        <FormControlLabel
          value="mpesa"
          control={<Radio />}
          label={"Mpesa"}
          onChange={() => paymentHandler("mpesa")} // Update selected payment method
        />
      </RadioGroup>

      {/* Show the appropriate component based on the selected payment method */}
      {status === 1 && (
        <CodPayment
          SelectedAddress={SelectedAddress}
          isPickup={isPickup}
          selectedPaymentMethod={selectedPaymentMethod} // Pass selected payment method
        />
      )}

      {status === 2 && (
        <CodPayment
          SelectedAddress={SelectedAddress}
          isPickup={isPickup}
          selectedPaymentMethod={selectedPaymentMethod} // Pass selected payment method
        />
      )}
    </div>
  );
};

export default Payment;
